import React from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "components/ui/hover-card";

const HoverCardDetail = ({ children, description, title, className }: { children: React.ReactNode; description: React.ReactNode; title: string; className?: string }) => {
  return (
    <HoverCard openDelay={2000} closeDelay={200}>
      <HoverCardTrigger className="p-0 m-0" asChild>
        {children}
      </HoverCardTrigger>

      <HoverCardContent className={`w-[350px] ${className}`}>
        <div className="flex justify-between space-x-4">
          <div className="space-y-1">
            <h4 className="text-lg font-semibold dark:text-white">{title}</h4>
            <p className="text-sm">{description}</p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default HoverCardDetail;
